'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// ./node_modules/get-proto/Object.getPrototypeOf.js
// module id = 328
// module chunks = 0